var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "omegaup-scoreboard px-2" },
    [
      _vm._t("scoreboard-header", function () {
        return [
          _c(
            "div",
            { staticClass: "text-center mt-4 pt-2" },
            [
              _c(
                "h2",
                { staticClass: "mb-4" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _vm._t("socket-status", function () {
                    return [
                      _c(
                        "sup",
                        {
                          class: _vm.socketClass,
                          attrs: { title: _vm.socketStatusTitle },
                        },
                        [_vm._v(_vm._s(_vm.socketStatus))]
                      ),
                    ]
                  }),
                ],
                2
              ),
              !_vm.finishTime
                ? _c("div", { staticClass: "clock" }, [_vm._v(_vm._s(_vm.INF))])
                : _c("omegaup-countdown", {
                    staticClass: "clock",
                    attrs: { "target-time": _vm.finishTime },
                  }),
            ],
            1
          ),
        ]
      }),
      _vm.rankingChartOptions && Object.keys(_vm.rankingChartOptions).length
        ? _c("highcharts", { attrs: { options: _vm.rankingChartOptions } })
        : _c("div", { staticClass: "bg-white text-center p-4 mb-3" }, [
            _vm._v(" " + _vm._s(_vm.T.rankingNoUsers) + " "),
          ]),
      _vm.showInvitedUsersFilter
        ? _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.onlyShowExplicitlyInvited,
                  expression: "onlyShowExplicitlyInvited",
                },
              ],
              staticClass: "toggle-contestants",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.onlyShowExplicitlyInvited)
                  ? _vm._i(_vm.onlyShowExplicitlyInvited, null) > -1
                  : _vm.onlyShowExplicitlyInvited,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.onlyShowExplicitlyInvited,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.onlyShowExplicitlyInvited = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.onlyShowExplicitlyInvited = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.onlyShowExplicitlyInvited = $$c
                  }
                },
              },
            }),
            _vm._v(" " + _vm._s(_vm.T.scoreboardShowOnlyInvitedIdentities)),
          ])
        : _vm._e(),
      _c("label", { staticClass: "float-right" }, [
        _vm._v(_vm._s(_vm.T.scoreboardShowParticipantsNames) + ": "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nameDisplayOptions,
                expression: "nameDisplayOptions",
              },
            ],
            staticClass: "form-control",
            attrs: { "data-scoreboard-options": "" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.nameDisplayOptions = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c(
              "option",
              { domProps: { value: _vm.ui.NameDisplayOptions.Name } },
              [_vm._v(_vm._s(_vm.T.wordsName))]
            ),
            _c(
              "option",
              { domProps: { value: _vm.ui.NameDisplayOptions.Username } },
              [_vm._v(" " + _vm._s(_vm.T.scoreboardAccountName) + " ")]
            ),
            _c(
              "option",
              {
                domProps: { value: _vm.ui.NameDisplayOptions.NameAndUsername },
              },
              [_vm._v(" " + _vm._s(_vm.T.scoreboardNameAndAccountName) + " ")]
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "table-responsive" }, [
        _c(
          "table",
          { staticClass: "table", attrs: { "data-table-scoreboard": "" } },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th"),
                  _c("th"),
                  _c("th", [_vm._v(_vm._s(_vm.T.contestParticipant))]),
                  _c("th", [_vm._v(_vm._s(_vm.T.wordsTotal))]),
                  _vm._l(_vm.problems, function (problem, index) {
                    return _c("th", { key: problem.alias }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#problems/" + problem.alias,
                            title: problem.alias,
                          },
                        },
                        [_vm._v(_vm._s(_vm.ui.columnName(index)))]
                      ),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _c(
              "tbody",
              [
                _vm._l(_vm.ranking, function (user, userIndex) {
                  return [
                    _vm.showUser(user.is_invited)
                      ? _c(
                          "tr",
                          {
                            key: `${user.username}-${user.virtual}`,
                            class: user.username,
                          },
                          [
                            _c("td", {
                              staticClass: "legend",
                              class: _vm.legendClass(userIndex),
                            }),
                            _c(
                              "td",
                              {
                                staticClass: "position",
                                attrs: { "data-table-scoreboard-position": "" },
                              },
                              [_vm._v(" " + _vm._s(user.place || "—") + " ")]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "user",
                                attrs: { "data-table-scoreboard-username": "" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.ui.rankingUsername(
                                        user,
                                        _vm.nameDisplayOptions
                                      )
                                    ) +
                                    " "
                                ),
                                user.country
                                  ? _c("img", {
                                      attrs: {
                                        alt: "",
                                        height: "11",
                                        src: `/media/flags/${user.country.toLowerCase()}.png`,
                                        title: user.country,
                                        width: "16",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c("td", [
                              _c("div", { staticClass: "points" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      user.total.points.toFixed(
                                        _vm.digitsAfterDecimalPoint
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "penalty" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(user.total.penalty) +
                                    " (" +
                                    _vm._s(_vm.totalRuns(user)) +
                                    ") "
                                ),
                              ]),
                            ]),
                            _vm._l(_vm.problems, function (problem) {
                              return _c(
                                "td",
                                {
                                  key: problem.alias,
                                  class: _vm.problemClassByAlias(
                                    user,
                                    problem.alias
                                  ),
                                },
                                [
                                  _vm.getUserProblem(user, problem.alias) &&
                                  _vm.getUserProblem(user, problem.alias).runs >
                                    0
                                    ? [
                                        _c("div", { staticClass: "points" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.renderPoints(
                                                  _vm.getUserProblem(
                                                    user,
                                                    problem.alias
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("div", { staticClass: "penalty" }, [
                                          _vm.showPenalty
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getUserProblem(
                                                      user,
                                                      problem.alias
                                                    ).penalty
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(
                                            " (" +
                                              _vm._s(
                                                _vm.getUserProblem(
                                                  user,
                                                  problem.alias
                                                ).runs
                                              ) +
                                              ") "
                                          ),
                                        ]),
                                      ]
                                    : [_vm._v(" - ")],
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm.visibleRanking.length
              ? _c("tfoot", [
                  _c(
                    "tr",
                    {
                      staticClass: "solve-stats",
                      attrs: { "data-table-scoreboard-solve-stats": "" },
                    },
                    [
                      _c("td", { staticClass: "legend" }),
                      _c("td"),
                      _c("td", { staticClass: "user" }, [
                        _vm._v(_vm._s(_vm.T.scoreboardSolvedRowTitle)),
                      ]),
                      _c("td"),
                      _vm._l(_vm.problems, function (problem) {
                        return _c("td", { key: problem.alias }, [
                          _c(
                            "div",
                            {
                              staticClass: "points",
                              attrs: {
                                title: _vm.T.scoreboardSolvedCountTooltip,
                                "data-solve-stats-count": "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.solveStats[problem.alias].solved) +
                                  " / " +
                                  _vm._s(_vm.visibleRanking.length) +
                                  " · " +
                                  _vm._s(
                                    _vm.solveStats[problem.alias].percentage
                                  ) +
                                  "% "
                              ),
                            ]
                          ),
                          _vm.solveStats[problem.alias].firstSolver
                            ? _c(
                                "div",
                                {
                                  staticClass: "penalty",
                                  attrs: {
                                    title: _vm.firstSolverTitle(problem.alias),
                                    "data-solve-stats-first-solver": "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.solveStats[problem.alias]
                                          .firstSolver.username
                                      ) +
                                      " @ " +
                                      _vm._s(
                                        _vm.solveStats[problem.alias]
                                          .firstSolver.time
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _c("div", { staticClass: "footer" }, [
        _vm._v(" " + _vm._s(_vm.lastUpdatedString) + " "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }